var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5755_3880",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5755_3880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2076 65C49.005 65.0004 48.8059 64.9499 48.6295 64.8535C48.4532 64.7571 48.3058 64.6181 48.2018 64.4501L39.3493 50.1748L22.7925 54.5257C22.5404 54.5844 22.2753 54.5604 22.0389 54.4575C21.8025 54.3546 21.6081 54.1787 21.4863 53.9575L2.13901 18.8013C2.04963 18.6403 2.00195 18.4607 2.00006 18.278C1.99817 18.0952 2.04212 17.9148 2.12815 17.752C2.21418 17.5893 2.33972 17.4492 2.49403 17.3436C2.64834 17.2381 2.82681 17.1702 3.01417 17.1459L19.4403 15.0107C19.6672 14.9803 19.8983 15.0151 20.105 15.1106C20.3117 15.2061 20.4848 15.3582 20.6028 15.5479L40.4334 47.5425L63.4773 41.4845L55.7944 30.9919C55.683 30.8428 55.6109 30.6698 55.5844 30.4878C55.5578 30.3057 55.5775 30.1201 55.6418 29.9471C55.7062 29.7741 55.8132 29.6189 55.9535 29.4949C56.0939 29.3709 56.2635 29.2818 56.4475 29.2354L67.2297 26.7718C67.4449 26.7223 67.6703 26.7327 67.8797 26.802C68.089 26.8713 68.2737 26.9966 68.4124 27.1633L77.7423 38.4136C77.864 38.5602 77.9461 38.7338 77.981 38.9187C78.0159 39.1036 78.0026 39.2941 77.9422 39.4728C77.8819 39.6514 77.7764 39.8128 77.6353 39.9421C77.4942 40.0715 77.322 40.1648 77.1343 40.2137L67.3342 42.7967L75.9124 54.4832C76.0178 54.6263 76.0873 54.7911 76.1154 54.9646C76.1434 55.1381 76.1293 55.3156 76.0741 55.4829C76.0189 55.6503 75.9242 55.8029 75.7974 55.9286C75.6706 56.0544 75.5152 56.1499 75.3436 56.2075L49.5816 64.9185C49.4621 64.9613 49.3362 64.985 49.2088 64.9885L49.2076 65ZM41.6933 49.5561L49.717 62.4916L73.1005 54.5774L64.9331 43.4476L41.6933 49.5561ZM4.99248 19.1549L23.0977 52.1023L38.125 48.1612L18.9879 17.356L4.99248 19.1549ZM58.7251 31.055L65.9116 40.852L74.8496 38.502L67.0741 29.1413L58.7251 31.055Z",
    fill: "#EF533F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaravel);
export default __webpack_public_path__ + "static/media/Laravel.ea899395978f169ae1759fae85babe2e.svg";
export { ForwardRef as ReactComponent };